// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"so-z","badgeLink":"to-z","category":"uo-z"};